"use client";
import clsx from "clsx";
import MetallicPaintLogo from "../metallic-paint-logo";
import StarBorder from "../star-button";

export default function Hero() {
  return (
    <section
      id="testimonials"
      aria-label="What our customers are saying"
      className="--font-geist-sans relative flex flex-col w-full h-full bg-transpaarent py-20 sm:py-10 z-1 bg-page-gradient"
    >
      <div className="absolute top-0 bottom-0 right-0 left-0">
      </div>
      <div className="border-t-0 mx-4 absolute z-10 inset-0  top-0 bottom-0 max-w-full bg-transparent opacity-10 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:24.95%_4rem] md:bg-[size:6rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]"></div>

      <div className="absolute top-0 pointer-events-none bottom-0 opacity-20 w-full bg-gradient from-midas-yellow-950/10 to-black/0 bg-[radial-gradient(ellipse_20%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))]"></div>

      <div className="absolute inset-x-0 -top-0 opacity-50 z-10 m-auto h-[27rem] max-w-lg sm:h-64 sm:max-w-7xl"></div>

      <div className="absolute top-0 left-0 right-0 bottom-0 pointer-events-none">
      </div>
      <Container className="relative z-20">
        <div className="flex flex-col w-full gap-0 mx-0 my-0 md:text-center">
          <MetallicPaintLogo size="150px" className="mx-auto" />

          <div className="relative flex flex-col w-full items-center">
            <div className="absolute bg-gradient-to-r from-transparent via-midas-yellow-500 to-transparent h-[2px] w-3/4 blur-sm" />
            <div className="absolute bg-gradient-to-r from-transparent via-midas-yellow-700 to-transparent h-px w-3/4" />
            <div className="absolute bg-gradient-to-r from-transparent via-midas-yellow-600 to-transparent h-[5px] w-1/4 blur-sm" />
            <div className="absolute bg-gradient-to-r from-transparent via-midas-yellow-300 to-transparent h-px w-1/4" />
          </div>
          <h1 className="font-geist text-center text-[40px] md:text-[55px] lg:text-7xl font-semibold tracking-tighter text-gray-100 mb-6 mt-8">
            Tudo que o seu
            <br />
            negócio toca
            <br />
            <span className="text-midas-yellow-500">vira ouro.</span>
          </h1>
          <div className="flex flex-col gap-4 items-center">
            <p className="mx-4 text-center text-lg md:text-xl tracking-tight text-gray-400 font-geist max-w-2xl">
              Estratégia, criatividade e tecnologia unidas para transformar qualquer empresa em uma máquina de vendas previsível. Do tráfego pago à TV aberta. Da automação ao depoimento do seu próximo cliente.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <StarBorder
                as="a"
                href="https://wa.me/558299542481?text=Quero%20ter%20resultados"
                target="_blank"
                rel="noopener noreferrer"
                className="custom-class"
                color="var(--midas-yellow-500)"
                speed="4s"
              >
                <span className="text-lg font-bold text-midas-yellow-500">Agendar Diagnóstico Gratuito</span>
              </StarBorder>
            </div>
          </div>

          {/* ── Métricas Adicionadas ── */}
          <div className="flex gap-8 md:gap-12 mt-20 pt-10 border-t border-neutral-800/50 w-full max-w-4xl mx-auto">
            <div className="flex flex-col items-center">
              <span className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-midas-yellow-400 to-amber-500 mb-2">
                +100
              </span>
              <span className="text-neutral-400 text-sm md:text-base font-medium tracking-wider uppercase text-center">
                Clientes atendidos
              </span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-midas-yellow-400 to-amber-500 mb-2">
                R$22M
              </span>
              <span className="text-neutral-400 text-sm md:text-base font-medium tracking-wider uppercase text-center">
                Em receita gerada
              </span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-midas-yellow-400 to-amber-500 mb-2">
                12+
              </span>
              <span className="text-neutral-400 text-sm md:text-base font-medium tracking-wider uppercase text-center">
                Segmentos de mercado
              </span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
export function Container({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      className={clsx("mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", className)}
      {...props}
    />
  );
}
